import { mapValues, unary } from 'lodash'
import Start from './Start'
import Correctness from './Correctness'
import Improvements from './Improvements'
import ImprovementsDescription from './ImprovementsDescription'
import HomeFacts from './HomeFacts'
import Complete from './Complete'
import StepContainer from './StepContainer'

export default mapValues(
  {
    Start,
    Correctness,
    Improvements,
    ImprovementsDescription,
    HomeFacts,
    Complete
  },
  unary(StepContainer)
)
